import type { ContactOutcome, EscalationDetail } from "@starsach/shared-types";
import type { TooltipId } from "../../lib/tooltips";

/** #462: the three outcomes, in the order they are shown; wire values, sentence case on screen through StatusPill / sentence(). */
export const OUTCOMES: ContactOutcome[] = ["contained", "not_contained", "escalated"];

export const OUTCOME_TONE: Record<ContactOutcome, "ok" | "neutral" | "warning" | "critical"> = {
  contained: "ok",
  not_contained: "warning",
  escalated: "neutral",
};

export const OUTCOME_HINT: Record<ContactOutcome, TooltipId> = {
  contained: "journeys.contained",
  not_contained: "journeys.not-contained",
  escalated: "journeys.escalated",
};

/** The detail beneath escalated, as it reads after the pill. */
export const ESCALATION_LABEL: Record<EscalationDetail, string> = {
  answered: "answered",
  transferred_out: "transferred out",
  abandoned: "abandoned in queue",
};
